import { Tooltip } from "@mui/material";
import classNames from "classnames";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { LockIcon } from "../../../../../../shared/icons/LockIcon";
import { useAppPopovers } from "../../../../../../app/state/popoverSlice/hook/use-app-popovers";
import { AppIconButton } from "../../../../../../shared/components/AppIconButton";
import { AppTooltip } from "../../../../../../shared/components/AppTooltip";
import { PublishLinkPopover } from "../PublishLinkPopover";
import { TValueForService } from "../../../../../../services/api/instances/storageApi/types/service_types";
import styles from "../styles.module.css";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { selectSpaValue } from "../../../../redux/selectors";
import { getSpaUpdatedValue } from "../../../../helpers/getSpaUpdatedValue";

interface Props {
  saveSpa: (value: TValueForService<"ai_agents_spa">) => void;
  isDisabled: boolean;
}

export const PasswordController = ({ saveSpa, isDisabled }: Props) => {
  const { handleClosePopover, handleOpenPopover } = useAppPopovers();
  const spaValue = useAppSelector(selectSpaValue);
  const { t } = useTranslation();

  const handleChangeSecuritySettings = (pass: string, checked: boolean) => {
    if (!spaValue) return;
    const updatedValue = getSpaUpdatedValue(spaValue, {
      uri_object: {
        ...spaValue?.spa_object?.uri_object,
        publish: {
          ...spaValue?.spa_object?.uri_object?.publish,
          only_for_platform_user: checked,
          password: pass,
        },
      },
    });
    saveSpa(updatedValue);
  };

  return (
    <>
      <AppTooltip
        classes={{ tooltip: styles["tooltip-font-size"] }}
        title={t("editor.password_tooltip")}
      >
        <span>
          <AppIconButton
            className={styles["action-button"]}
            onClick={(e) => handleOpenPopover(e, "publish_link_popover", null)}
            disabled={isDisabled}
          >
            <LockIcon
              className={classNames(styles["lock-icon"], {
                [styles["disabled"]]: isDisabled,
              })}
            />
          </AppIconButton>
        </span>
      </AppTooltip>
      <PublishLinkPopover
        closePopover={handleClosePopover}
        handleChangePublish={handleChangeSecuritySettings}
      />
    </>
  );
};
